import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import Paginate from 'vuejs-paginate'
import VueSweetalert2 from 'vue-sweetalert2'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './styles/app.scss'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

Vue.config.productionTip = false

Vue.component('paginate', Paginate)
Vue.use(VueSweetalert2)

NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
